<template>
  <div v-if="apps && apps.length > 0" class="table-page">
    <!--过滤栏 -->
    <search-wrapper>
      <a-row :gutter="20">
        <a-col :span="6" :xl="6">
          <a-form-item label="应用编号">
            <a-select :allowClear="false" defaultValue="" v-model="targetAppId">
              <a-select-option value="">全部</a-select-option>
              <a-select-option :key="app.appId" :value="app.appId" v-for="app in apps">
                {{ app.appId + ' | ' + app.appName  }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item class="operation-group">
            <a-button icon="search" @click="handleSearch">查询</a-button>
            <a-button class="reset-btn" icon="sync" @click="resetSearch">重置</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </search-wrapper>
    <!--昨日数据 -->
    <b style="font-size: 14px">昨日关键指标
      <a-tooltip style="margin-left: 9px">
        <template slot="title">
          <span>黑色数字是成功调用次数</span><br/>
          <span>红色数字是失败调用次数</span>
        </template>
        <a-icon type="info-circle" />
      </a-tooltip>
    </b>
    <div style="margin-top: 20px">
      <a-row :gutter="[20,20]" style="margin: 0px">
        <a-col :key="yesterday.apiCategoryName" :span="6" v-for="yesterday in yesterdayList">
          <a-card :bordered="false">
            <p class="apiRequest__yesterday__statistics__title">{{yesterday.apiCategoryName}}</p>
            <p style="text-align: center">
              <span class="apiRequest__yesterday__statistics__value">{{yesterday.successQuantity}}</span>
              <span v-if="yesterday && yesterday.errorQuantity && yesterday.errorQuantity > 0" class="apiRequest__yesterday__statistics__error__value">(失败:{{yesterday.errorQuantity}})</span>
            </p>
          </a-card>
        </a-col>
      </a-row>
    </div>

    <!-- 图标头部 日期，日期变更影响当前页全部 -->
    <div style="margin-top: 24px;width: 100%">
      <a-row style="width: 50%;display: inline-block">
        <a-col :span="12">
          <a-range-picker :allowClear="false" @change="handleDateRangeChange" v-model="dateRange" format="YYYY-MM-DD" style="width: 100%">
            <a-icon slot="suffixIcon" type="calendar" />
          </a-range-picker>
        </a-col>
        <a-col :span="12">
          <a-cascader style="margin-left: 20px;width: 100%" :options="options" :value="cascaderTarget" placeholder="全部类型/全部接口" @change="handleCascaderChange"></a-cascader>
        </a-col>
      </a-row>
      <a class="apiRequest__download" @click="downloadExcel">
        <a-icon type="download" />
        下载表格
      </a>
    </div>

    <!-- 分页表格 -->
    <global-table
      ref="table"
      :columns="columns"
      :dataRender="loadData"
      style="height:700px;margin-top: 24px"
      filled
    />
  </div>
  <a-empty v-else style="height: 100%"></a-empty>
</template>

<script>
import SearchWrapper from '@/components/SearchWrapper';
import GlobalTable from '@/components/GlobalTable';
import moment from 'moment';
import {
  listApiRequestDailyStatisticsByPage, getYesterdayApiRequestStatistics, getAllApp, getApiCascader,
} from '@/services/modules/data';
import {
  Button, Row, Col, Select, Form, Card, DatePicker, Empty, Tooltip, Cascader,
} from 'ant-design-vue';

export default {
  name: 'ApiRequestStatistics',
  components: {
    SearchWrapper,
    GlobalTable,
    'a-row': Row,
    'a-col': Col,
    'a-button': Button,
    'a-select': Select,
    'a-select-option': Select.Option,
    'a-form-item': Form.Item,
    'a-card': Card,
    'a-range-picker': DatePicker.RangePicker,
    'a-empty': Empty,
    'a-tooltip': Tooltip,
    'a-cascader': Cascader,
  },
  data() {
    return {
      apps: [],
      options: [],
      targetAppId: '',
      dateRange: this.getInitDateRange(),
      yesterdayList: [],
      cascaderTarget: [],
    };
  },
  mounted() {
    getAllApp().then((res) => {
      if (res && res.result && res.result.length > 0) {
        this.apps = res.result;
        this.requestYesterday();
        this.requestApiCascader();
      }
    });
  },
  computed: {
    columns() {
      return [
        {
          title: '接口名称',
          key: 'apiName',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '接口业务类型',
          key: 'apiCategoryName',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '成功调用次数',
          key: 'successQuantity',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '失败调用次数',
          key: 'errorQuantity',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '累积调用次数',
          key: 'totalQuantity',
          align: 'left',
          minWidth: 125,
        },
      ];
    },
    defaultQueryParams() {
      return {
        appId: this.targetAppId,
        beginDate: this.dateRange[0].format('YYYY-MM-DD'),
        endDate: this.dateRange[1].format('YYYY-MM-DD'),
        apiCategory: (this.cascaderTarget && this.cascaderTarget.length > 0) ? this.cascaderTarget[0] : '',
        apiId: (this.cascaderTarget && this.cascaderTarget.length > 1) ? this.cascaderTarget[1] : '',
      };
    },
  },
  methods: {
    loadData(parameter) {
      return listApiRequestDailyStatisticsByPage({ ...parameter, ...this.defaultQueryParams });
    },
    requestYesterday() {
      const yesterdayParam = {
        beginDate: moment().startOf('day').subtract(1, 'days').format('YYYY-MM-DD'),
        endDate: moment().startOf('day').subtract(1, 'days').format('YYYY-MM-DD'),
        appId: this.targetAppId,
      };
      getYesterdayApiRequestStatistics(yesterdayParam).then((res) => {
        if (res && res.result && res.result.length > 0) {
          this.yesterdayList = res.result;
        } else {
          this.yesterdayList = [];
        }
      });
    },
    requestApiCascader() {
      getApiCascader().then((res) => {
        if (res && res.result && res.result.length > 0) {
          this.options = res.result;
        }
      });
    },
    handleDateRangeChange(dates) {
      this.dateRange = dates;
      this.handleSearch();
    },
    handleSearch() {
      this.$refs.table.refresh(true);
      this.requestYesterday();
    },
    resetSearch() {
      this.cascaderTarget = [];
      this.targetAppId = '';
      this.dateRange = this.getInitDateRange();
      this.handleSearch();
    },
    getInitDateRange() {
      const defaultSelectDate = {
        startDate: moment().startOf('day').subtract(30, 'days'),
        endDate: moment().startOf('day').subtract(1, 'days'),
      };
      return [defaultSelectDate.startDate, defaultSelectDate.endDate];
    },
    downloadExcel() {
      const url = `${process.env.VUE_APP_API_BASE_URL}/export/exportApiRequestXls`;
      const params = this.defaultQueryParams;
      const tempForm = document.createElement('form');
      tempForm.action = url;
      tempForm.target = '_self';
      tempForm.method = 'post';
      tempForm.style.display = 'none';
      Object.keys(params).forEach(key => {
        if (!(params[key] === '' || params[key] === undefined)) {
          const opt = document.createElement('textarea');
          opt.name = key;
          opt.value = params[key];
          tempForm.appendChild(opt);
        }
      });
      document.body.appendChild(tempForm);
      // 提交数据
      tempForm.submit();
    },
    handleCascaderChange(value) {
      this.cascaderTarget = value;
      this.handleSearch();
    },
  },
};
</script>

<style lang="less" scoped>
  .apiRequest__yesterday__statistics__title{
    margin-top: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 20px;
    text-align: center;
  }
  .apiRequest__yesterday__statistics__value{
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 40px;
    text-align: center;
  }
  .apiRequest__yesterday__statistics__error__value{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F5222D;
    line-height: 17px;
    text-align: center;
    margin-left: 8px;
  }
  .apiRequest__download {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #178FFF;
    line-height: 20px;
    float: right;
    margin-top: 12px;
  }
</style>
